require('lib/browser_required')('module/browser')

const Browser = require('./browser_model')

module.exports = new Browser()
